module.exports = __webpack_public_path__ + "img/mode_bg_3.713ba355.jpeg";